export type AuthUserData = {
  access_token: string;
  refresh_token: string;
  expires_in: string;
};
